import axios from 'axios';
import axiosRetry, { IAxiosRetryConfig } from 'axios-retry';

interface RequestOptions {
    headers?: { [key: string]: string };
    apiVersion?: string;
    signal?: AbortSignal;
    'axios-retry'?: IAxiosRetryConfig;
}

class HttpService {
    constructor() {
        axiosRetry(axios, { retries: 2 });
    }

    async get<T>(url: string, options?: RequestOptions) {
        return axios
            .get<T>(url, {
                ...options,
                headers: this._buildHeaders(options)
            })
            .then(resp => resp.data);
    }

    async post<T>(url: string, data: any, options?: RequestOptions) {
        return axios
            .post<T>(url, data, {
                ...options,
                headers: this._buildHeaders(options)
            })
            .then(resp => resp.data);
    }

    async put<T>(url: string, data: any, options?: RequestOptions) {
        return axios
            .put<T>(url, data, {
                ...options,
                headers: {
                    'Content-Type': 'application/json-put+json',
                    ...this._buildHeaders(options)
                }
            })
            .then(resp => resp.data);
    }

    async patch<T>(url: string, data: any, options?: RequestOptions) {
        return axios
            .patch<T>(url, data, {
                ...options,
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    ...this._buildHeaders(options)
                }
            })
            .then(resp => resp.data);
    }

    async delete<T>(url: string, data?: any, options?: RequestOptions) {
        return axios
            .delete<T>(url, {
                ...options,
                headers: {
                    'Content-Type': 'application/json-delete+json',
                    ...this._buildHeaders(options)
                },
                data
            })
            .then(resp => resp.data);
    }

    private _buildHeaders(options?: RequestOptions) {
        return {
            'Accept-Version': options?.apiVersion || '',
            ...options?.headers
        };
    }
}

export { HttpService };
